/* VAPA SESSION — Sticky Add to Cart */

(function() {
  'use strict';

  function initStickyATC() {
    // Kun på produktsider
    if (!document.querySelector('.product-details, [data-template="product"]')) return;

    // Find eksisterende ATC knap
    const atcButton = document.querySelector('.add-to-cart-button, [id*="BuyButtons-ProductSubmitButton"], button[name="add"]');
    if (!atcButton) return;

    // Find produkt titel og pris
    const productTitle = document.querySelector('.product__title, [class*="product-title"] h1, [class*="product-title"] h2');
    const productPrice = document.querySelector('product-price .price, .product-details .price, .price');

    if (!atcButton) return;

    // Opret sticky bar
    const stickyBar = document.createElement('div');
    stickyBar.className = 'vapa-sticky-atc';
    stickyBar.innerHTML = `
      <span class="vapa-sticky-atc__title">${productTitle ? productTitle.textContent.trim() : ''}</span>
      <span class="vapa-sticky-atc__price">${productPrice ? productPrice.textContent.trim() : ''}</span>
      <button class="vapa-sticky-atc__btn" type="button">Add to Cart</button>
    `;
    document.body.appendChild(stickyBar);

    // Klik videresendes til den rigtige ATC knap
    stickyBar.querySelector('.vapa-sticky-atc__btn').addEventListener('click', function() {
      atcButton.click();
    });

    // Vis sticky bar når original ATC er ude af syne
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) {
          stickyBar.classList.add('vapa-sticky-atc--visible');
        } else {
          stickyBar.classList.remove('vapa-sticky-atc--visible');
        }
      });
    }, { threshold: 0, rootMargin: '-60px 0px 0px 0px' });

    observer.observe(atcButton);
  }

  // Init ved DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyATC);
  } else {
    initStickyATC();
  }

  // Init ved Shopify section events (theme editor)
  document.addEventListener('shopify:section:load', initStickyATC);

})();
